import React from 'react';
import { LightbulbIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { CTAButton } from '../ui/CTAButton';
import { problems } from '../../data/problems';
export function Problems() {
  return <section className="w-full bg-paper px-4 py-16 md:py-24" data-id="element-231" data-mp="1d0fwj2gzjkpc">
      <div className="mx-auto max-w-5xl" data-id="element-232" data-mp="1hzj1kmwytqxb">
        <SectionHeader kicker="Does any of this sound familiar?" title="6 Professional Challenges This Collection Was Designed to Address" intro={['If you work in hair restoration, you may recognize some of these challenges.']} data-id="element-233" data-mp="1hy80iuuwmx9w" />

        <ol className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-234" data-mp="u8dougmbner8">
          {problems.map((problem, i) => <li key={problem.title} className="flex flex-col rounded-3xl bg-white p-6 shadow-card md:p-7" data-id="element-235" data-mp="z16sf1620h1q" data-mpi={i}>
              <div className="flex items-start gap-4" data-id="element-236" data-mp="1jye46a83ilp">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy font-display text-xl font-black text-gold" data-id="element-237" data-mp="6jkq6cebessx">
                  {i + 1}
                </span>
                <h3 className="font-display text-xl font-black leading-tight text-heading" data-id="element-238" data-mp="185wnhug868t">{problem.title}</h3>
              </div>
              <div className="mt-4 space-y-3 text-[16px] leading-relaxed text-body" data-id="element-239" data-mp="3sls19suqvn37">
                {problem.body.map(p => <p key={p} data-id="element-240" data-mp="3nngs7kc9xgm1">{p}</p>)}
              </div>
              <div className="mt-auto pt-5" data-id="element-241" data-mp="3jn6ka24x8g4j">
                <p className="flex gap-3 rounded-2xl bg-paper p-4 text-[15px] leading-snug text-heading" data-id="element-242" data-mp="3jjsk90jqcj09">
                  <LightbulbIcon className="mt-0.5 h-5 w-5 shrink-0 text-blue" aria-hidden="true" data-id="element-243" data-mp="39nz9nmpkmzl4" />
                  <span data-id="element-244" data-mp="34ow4815oircm">
                    <strong className="text-blue" data-id="element-245" data-mp="34pec5v1peu0d">The Blueprint approach:</strong> {problem.approach}
                  </span>
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 rounded-3xl bg-navy p-7 text-center md:p-10" data-id="element-246" data-mp="12x9mkq7og8st">
          <h3 className="text-balance font-display text-2xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-247" data-mp="2xdzwgkoaf63h">
            The challenge isn’t always a lack of information
          </h3>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-248" data-mp="2nfk0o4ebf8nn">
            Sometimes, the real challenge is organizing the information you already have.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-[16px] leading-relaxed text-white/75" data-id="element-249" data-mp="2sewoosgxalrt">
            HAIR TRANSPLANT BLUEPRINT™ brings related educational topics into one collection, giving you a practical starting
            point for building a more organized professional reference library.
          </p>
        </div>

        <div className="mt-10" data-id="element-250" data-mp="3b54nwzhi4s2q">
          <CTAButton label="Explore the complete Blueprint" sub="One-time payment · $27 USD · Digital product" tone="light" data-id="element-251" data-mp="3b4d2uilj6cqp" />
        </div>
      </div>
    </section>;
}